function copy(value, context) {
  if (value == null)
    return value;
  return { ...value, fields: value.fields.map(copyFormFieldsPanelItem) };
  function copyFormFieldsPanelItem(item) {
    return {
      ...item,
      tableColumnId: context.replacementContext.tableColumnIds.get(item.tableColumnId) ?? item.tableColumnId
    };
  }
}
export {
  copy
};
//# sourceMappingURL=table-form-fields.js.map